// One spot where this is used
// eslint-disable-next-line no-restricted-imports, import/no-extraneous-dependencies
import { hotjar as hj } from "react-hotjar";

export enum Event {
  UserLogin = "user_login",
  UserSignUp = "user_signup",
  UserVerifyEmail = "user_verify_email",
  AllPagesPopupModalSubmit = "all_pages_popup_modal_submit",
  AllPagesPopupModalClose = "all_pages_popup_modal_close",
  AftermarketPurchaseVehicleDetails = "aftermarket_purchase_vehicle_details",
  AftermarketPurchaseSafetyReturnHome = "aftermarket_purchase_safety_return_home",
  AftermarketPurchaseCustomerInformation = "aftermarket_purchase_customer_information",
  AftermarketPurchaseConfirmEmail = "aftermarket_purchase_confirm_email",
  AftermarketConfirmCoverage = "aftermarket_confirm_coverage",
  AftermarketPaymentFrequency = "aftermarket_payment_frequency",
  AftermarketPurchaseViewSignedContract = "aftermarket_purchase_view_signed_contract",
  AftermarketPurchaseEmailSignedContract = "aftermarket_purchase_email_signed_contract",
  AftermarketPurchaseRegenerateContracts = "aftermarket_purchase_regenerate_contracts",
  AftermarketPurchaseNoCoverages = "aftermarket_purchase_no_coverages",
  AftermarketPurchaseFreeInstantQuote = "aftermarket_purchase_free_instant_quote",
  AftermarketPurchaseAvailableCoverages = "aftermarket_purchase_available_coverages",
  AftermarketPurchaseVehicleDoesntMatch = "aftermarket_purchase_vehicle_doesnt_match",
  AftermarketConvertPurchaseFreeInstantQuote = "aftermarket_convert_purchase_free_instant_quote",
  WarrantyFilter = "warranty_filter_enabled",
  WarrantySampleContract = "warranty_sample_contract",
  PrequalificationCompletePrime = "prequalification_complete_prime",
  ProfileWarrantyProtectionResumePurchase = "profile_warranty_protection_resume_purchase",
  PageNotFound = "page_not_found",
  PurchasePersonalInfoAddressMortgage = "purchase_personal_info_address_mortgage",
  PurchasePersonalInfoIncomeEmployment = "purchase_personal_info_income_employment",
  ConsumerFinancingConfirmEmail = "consumer_financing_confirm_email",
  ConsumerFinancingPersonalDetails = "consumer_financing_personal_details",
}

export const hotjar = {
  event: (event: Event) => {
    if (hj.initialized()) {
      hj.event(event);
    }
  },
  identify: (userId: string | null, properties: Record<string, unknown>) => {
    if (hj.initialized()) {
      hj.identify(userId, properties);
    }
  },
  initialize: (hjid: number, hjsv: number, debug?: boolean) => {
    hj.initialize(hjid, hjsv, debug);
  },
  initialized: () => {
    return hj.initialized();
  },
};

export default {};
